export default "__VITE_ASSET__imqF9MgJ__"